const name = 'inOut';

export const INITIALIZE_REQUEST = `${name}/INITIALIZE_REQUEST`;
export const INITIALIZE_SUCCESS = `${name}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${name}/INITIALIZE_FAILURE`;

export const FETCH_RECORDS_REQUEST = `${name}/FETCH_RECORDS_REQUEST`;
export const FETCH_RECORDS_SUCCESS = `${name}/FETCH_RECORDS_SUCCESS`;
export const FETCH_RECORDS_FAILURE = `${name}/FETCH_RECORDS_FAILURE`;

export const SET_PERIOD = `${name}/SET_PERIOD`;
export const SET_CANCEL_TOKEN = `${name}/SET_CANCEL_TOKEN`;

export const IN_OUT_FILTERS = 'inOutFilters';



// WEBPACK FOOTER //
// ./src/sites/inOut/constants.js